import { useNavigate } from 'react-router-dom';
import ViewNavigate from '../utils/ViewNavigate';

export default function NaviButton({to,className,children,handleBtn=()=>{return true}}) {
  const navigate=ViewNavigate(useNavigate(),to);
  return (
    <button 
    className={className}
    onClick={()=>handleBtn()&&navigate()}>
      {children}  
    </button>
  );
}